module.exports = __webpack_public_path__ + "static/media/sparksLogoBlue2.b77caa8d.png";